import { render, staticRenderFns } from "./DiscountRatesTableWidget.vue?vue&type=template&id=1dfada14&"
import script from "./DiscountRatesTableWidget.vue?vue&type=script&lang=js&"
export * from "./DiscountRatesTableWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports